<div nz-flex [nzGap]="'small'" [nzVertical]="true">
  <div class="header-wrapper">
    <h1>Lista kont rozliczeniowych</h1>
  </div>

  <nz-table
    #profilesTable
    [nzData]="profiles()"
    [nzBordered]="true"
    [nzLoading]="loading()"
    [nzShowPagination]="false"
    nzTableLayout="fixed"
  >
    <thead>
      <tr>
        <th>Firma</th>
        <th>Kod świadczeniodawcy</th>
        <!-- <th>Oddział NFZ</th> -->

        <th>Oddział</th>
        <th>Auth URL</th>
        <th>Broker URL</th>
        <th>Użytkownik</th>
        <th>Rola</th>
        <th class="mhs-table-action-header">Akcja</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let profile of profilesTable.data">
        <td>{{ profile.companyName || '-' }}</td>
        <td>{{ profile.serviceProviderCode || '-' }}</td>
        <!-- <td>{{ profile.nhfBranchCode || '-' }}</td> -->

        <td>{{ profile.branchName || '-' }}</td>
        <td>{{ profile.settlementWsTransportProfile?.authUrl || '-' }}</td>
        <td>{{ profile.settlementWsTransportProfile?.brokerUrl || '-' }}</td>
        <td>{{ profile.settlementWsTransportProfile?.user || '-' }}</td>
        <td>{{ toLoginTypeLabel(profile.settlementWsTransportProfile?.roleType || '-') }}</td>
        <td style="text-align: center">
          <a
            nz-dropdown
            [nzDropdownMenu]="userActionsMenu"
            nz-button
            nzType="default"
            nzShape="circle"
          >
            <nz-icon nzType="menu-fold" nzTheme="outline" />
          </a>
          <nz-dropdown-menu #userActionsMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="changePasswordClick(profile.serviceProviderCode!)">
                Zmień hasło
              </li>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
